import client from './axiosConfig';

export const getAllAnnouncements = (params) => {
    const config = {
        url:`/dashboard/announcements/`,
        method: "GET",
        params
    }

    const response = client(config);
    return response;
}

export const getAnnouncementById = (id) => {
    const config = {
        url:`/dashboard/announcements/${id}/`,
        method: "GET",
    }

    const response = client(config);
    return response;
}

export const createAnnouncement = (data) => {
    const config = {
        url: `/dashboard/announcements/`,
        method: "POST",
        data
    }

    const response = client(config);
    return response;
}

export const editAnnouncementById = (data, id) => {
    const config = {
        url: `/dashboard/announcements/${id}/`,
        method: "PATCH",
        data
    }

    const response = client(config);
    return response;
}

export const deleteAnnouncementById = (id) => {
    const config = {
        url: `/dashboard/announcements/${id}/`,
        method: "DELETE",
    }

    const response = client(config);
    return response;
}
